import React from 'react';
import { Card, Form, Select, Row, Col, Input, InputNumber } from 'antd';

const { Option } = Select;

export default function ConditionsSection({
  formaPagoOptions,
  metodoPagoOptions,
  tipoComprobanteOptions,
}) {
  return (
    <Card title="Condiciones" size="small" style={{ marginBottom: '12px' }} styles={{ body: { padding: '12px' } }}>
      <Row gutter={[8, 8]}>
        <Col xs={24} lg={24}>
          <Form.Item shouldUpdate={(prev, curr) => prev.metodo_pago !== curr.metodo_pago} style={{ marginBottom: '8px' }}>
            {({ getFieldValue, setFieldsValue }) => {
              const isPPD = getFieldValue('metodo_pago') === 'PPD';
              const currentForma = getFieldValue('forma_pago');
              if (isPPD && currentForma !== '99') {
                setFieldsValue({ forma_pago: '99' });
              }

              return (
                <Form.Item 
                  name="forma_pago" 
                  style={{ marginBottom: '0px' }}
                  rules={[{ required: true, message: 'Seleccione la forma de pago' }]}
                >
                  <Select
                    size="small"
                    placeholder="Forma de Pago"
                    showSearch
                    disabled={isPPD}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.children || '').toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {formaPagoOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item
            name="metodo_pago"
            style={{ marginBottom: '8px' }}
            rules={[{ required: true, message: 'Seleccione el método de pago' }]}
          >
            <Select
              size="small"
              placeholder="Método de Pago"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children || '').toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {metodoPagoOptions.map(option => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item
            name="tipo_comprobante"
            style={{ marginBottom: '8px' }}
            rules={[{ required: true, message: 'Seleccione el tipo de comprobante' }]}
          >
            <Select
              size="small"
              placeholder="Tipo de Comprobante"
            >
              {tipoComprobanteOptions.map(option => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        
        <Col xs={24} lg={12}>
          <Form.Item
            name="moneda"
            initialValue="MXN"
            style={{ marginBottom: '8px' }}
            rules={[{ required: true, message: 'Seleccione la moneda' }]}
          >
            <Select
              size="small"
              placeholder="Moneda"
            >
              <Option value="MXN">MXN - Peso Mexicano</Option>
              <Option value="USD">USD - Dólar Americano</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} lg={12}>
          <Form.Item shouldUpdate={(prev, curr) => prev.moneda !== curr.moneda} style={{ marginBottom: '8px' }}>
            {({ getFieldValue }) => {
              const moneda = getFieldValue('moneda');
              const isForeign = moneda && moneda !== 'MXN';

              return (
                <Form.Item
                  name="tipo_cambio"
                  style={{ marginBottom: '0px' }}
                  rules={[
                    { required: isForeign, message: 'Ingrese el tipo de cambio' },
                    { 
                      validator: (_, value) => {
                        if (isForeign && (!value || Number(value) <= 0)) {
                          return Promise.reject(new Error('El tipo de cambio debe ser mayor a 0'));
                        }
                        return Promise.resolve();
                      }
                    }
                  ]}
                >
                  <InputNumber
                    size="small"
                    placeholder="Tipo de Cambio"
                    style={{ width: '100%' }}
                    disabled={!isForeign}
                    min={0.0001}
                    step={0.0001}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>

        <Col xs={24} lg={24}>
          <Form.Item
            name="condiciones_pago"
            label="Notas / Observaciones (opcional)"
            style={{ marginBottom: '0px' }}
          >
            <Input.TextArea
              rows={3}
              placeholder="Notas u observaciones para mostrar en el PDF"
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
}
